import React, { useRef, useState } from 'react';

export default function TagInput({ value = [], onChange, placeholder = '', transform = (v) => v }) {
  const [draft, setDraft] = useState('');
  const inputRef = useRef(null);

  const commit = (raw) => {
    const items = raw
      .split(/[\s,]+/)
      .map((v) => transform(v.trim()))
      .filter(Boolean);
    if (items.length) {
      const next = [...value];
      for (const item of items) if (!next.includes(item)) next.push(item);
      onChange(next);
    }
    setDraft('');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      commit(draft);
    } else if (e.key === 'Backspace' && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div
      className="form-control d-flex flex-wrap align-items-center gap-1"
      style={{ height: 'auto', minHeight: 38, cursor: 'text' }}
      onClick={() => inputRef.current?.focus()}
    >
      {value.map((tag) => (
        <span key={tag} className="badge text-bg-secondary d-inline-flex align-items-center gap-1">
          {tag}
          <span
            role="button"
            aria-label={`remove ${tag}`}
            onClick={(e) => {
              e.stopPropagation();
              onChange(value.filter((t) => t !== tag));
            }}
            style={{ cursor: 'pointer', lineHeight: 1 }}
          >
            ×
          </span>
        </span>
      ))}
      <input
        ref={inputRef}
        className="border-0 flex-grow-1 p-0"
        style={{ outline: 'none', minWidth: 80, background: 'transparent' }}
        value={draft}
        placeholder={value.length ? '' : placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => commit(draft)}
      />
    </div>
  );
}
